export default "__VITE_ASSET__BYFtvc5T__"